import Forfatter from "./Forfatter";

export default function (Vue, $) {
  const vueForfatter = new Vue({
    data() {
      return {
        books: [],
        loading: false,
      };
    },
    render(h) {
      return h(Forfatter, {
        props: {
          books: this.books,
          loading: this.loading
        }
      });
    }
  });

  vueForfatter.$mount($('#lf_forfatter_results')[0]);

  let previous;
  $("#lf_forfatter_search_form").submit(function (e) {
    e.preventDefault(); // avoid to execute the actual submit of the form.
    if (previous) {
      previous.abort();
    }
    Vue.set(vueForfatter, 'books', []);
    Vue.set(vueForfatter, 'loading', true);

    const form = $(this);

    previous = $.ajax({
      method: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success(data) {
        Vue.set(vueForfatter, 'books', data);
        Vue.set(vueForfatter, 'loading', false);
      }
    });
  });
}
